import classNames from 'classnames';
import {
    ButtonSize,
    ButtonTheme,
    ButtonView,
    Icon as LegoIcon,
    Link,
    Menu,
    PopupDirection
} from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { BasePopupProps } from '../../typings/common';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';
import { ScopedPopup } from '../ScopedPopup/ScopedPopup';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';

import './ActionsMenu.css';

export interface ActionsMenuItem {
    // поля text и val нельзя переименовывать, т.к. эти названия полей нужны для блока из Лего
    text: React.ReactNode;
    val: string;
    elemMods?: {
        disabled: boolean;
    };
}

export interface ActionsMenuGroup {
    title?: string;
    items: ActionsMenuItem[];
}

export interface ActionsMenuProps {
    buttonView?: ButtonView;
    buttonTheme?: ButtonTheme;
    buttonSize?: ButtonSize;
    buttonTone?: string;
    disabled?: boolean;
    icon?: Shape2Icon;
    actions?: ActionsMenuGroup[];
    actionVal?: string;
    className?: string;
    closeOnItemClick?: boolean;
    onItemSelect?: (
        event: React.MouseEvent<HTMLElement>,
        value: string
    ) => void;
    isLink?: boolean;
    text?: string;
    hasArrow?: boolean;
    popupPosition?: keyof PopupPositionsType;
}

interface PopupPositionsType {
    left: Array<PopupDirection>;
    right: Array<PopupDirection>;
    'right-alt': Array<PopupDirection>;
}

const PopupPositions: PopupPositionsType = {
    left: ['bottom-left', 'top-left'],
    right: ['bottom-right', 'top-right'],
    'right-alt': ['right-top', 'right-bottom']
};

const BLOCK = 'actions-menu';

export class ActionsMenu extends React.PureComponent<
    ActionsMenuProps & BasePopupProps
> {
    render() {
        const {
            buttonTheme = 'clear',
            buttonView = 'classic',
            buttonSize = 's',
            className,
            switchPopupState,
            isLink = false,
            hasArrow,
            isPopupVisible,
            disabled = false
        } = this.props;

        if (isLink) {
            return (
                <>
                    <Link
                        theme="normal"
                        cls={classNames(
                            Bem.cls({ block: BLOCK, mods: { link: true } }),
                            className
                        )}
                        onClick={switchPopupState}
                    >
                        {this.renderContent()}
                    </Link>
                    {this.renderPopup()}
                </>
            );
        }

        return (
            <>
                <ButtonDecorator
                    theme={buttonTheme}
                    view={buttonView}
                    size={buttonSize}
                    cls={classNames(Bem.cls(BLOCK), className)}
                    onClick={switchPopupState}
                    disabled={disabled}
                    iconRight={
                        hasArrow ? (
                            <LegoIcon
                                size={'ns'}
                                direction={isPopupVisible ? 'top' : 'bottom'}
                                type={'arrow'}
                            />
                        ) : (
                            undefined
                        )
                    }
                >
                    {this.renderContent()}
                </ButtonDecorator>
                {this.renderPopup()}
            </>
        );
    }

    private renderContent() {
        const { icon, text } = this.props;

        return (
            <>
                {icon ? (
                    <Shape2
                        icon={icon}
                        width={16}
                        height={16}
                        cls={Bem.cls(BLOCK, 'icon')}
                    />
                ) : null}
                {text ? text : null}
            </>
        );
    }

    private renderPopup() {
        const {
            popupPosition = 'right',
            actions = [],
            actionVal,
            isPopupVisible,
            closePopup,
            className
        } = this.props;

        return (
            <ScopedPopup
                theme="normal"
                mix={{ block: BLOCK, elem: 'popup' }}
                target={'anchor'}
                anchor={this}
                directions={PopupPositions[popupPosition]}
                autoclosable={true}
                visible={isPopupVisible}
                onOutsideClick={closePopup}
            >
                <Menu
                    cls={classNames(Bem.cls(BLOCK, 'menu'), className)}
                    type={'default'}
                    theme="normal"
                    size="m"
                    onClick={this.onMenuItemClick}
                    items={actions}
                    val={actionVal}
                />
            </ScopedPopup>
        );
    }

    private onMenuItemClick = (
        event: React.MouseEvent<HTMLElement>,
        value: string
    ) => {
        const {
            onItemSelect,
            closeOnItemClick = true,
            closePopup
        } = this.props;

        if (onItemSelect) {
            onItemSelect(event, value);
        }

        if (closeOnItemClick) {
            closePopup();
        }
    };
}
